import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../services/firebase";
import "./styles.css";

import Container from "../../../components/Container";

import ValvulaBloqueioForm from "./ValvulaBloqueioForm";
import ValvulaControleForm from "./ValvulaControleForm";
import ValvulaPSVForm from "./ValvulaPSVForm";
import { Row, Col, Button } from "antd";
import { SettingOutlined } from "@ant-design/icons";

function ValveForm() {
  const { tipo, id } = useParams();

  const [tipoValvula, setTipoValvula] = useState(0);
  const [valvula, setValvula] = useState(null);

  // pega usuário salvo na sessão (se existir)
  const usuario = JSON.parse(sessionStorage.getItem("seepilUsuario") || "{}");

  // 1) detecta se a URL é rota de cliente
  let isClienteRoute = false;
  if (typeof window !== "undefined") {
    const path = window.location.pathname || "";
    isClienteRoute = path.startsWith("/cliente/");
  }

  // 2) detecta cliente pelo tipoUsuario só pra reforçar
  const isClienteTipo =
    typeof usuario?.tipoUsuario === "string" &&
    usuario.tipoUsuario.toLowerCase() === "cliente";

  // 3) considera cliente se QUALQUER uma das duas condições for verdadeira
  const isCliente = isClienteRoute || isClienteTipo;

  // Determina o tipo de usuário para o Container
  const userType = isCliente ? "cliente" : "admin";

  const tituloPagina = valvula ? "Visualizar válvula" : "Cadastrar válvula";

  useEffect(() => {
    async function fetchValvula() {
      if (tipo && id) {
        if (tipo === "Bloqueio") setTipoValvula(0);
        if (tipo === "Controle") setTipoValvula(1);
        if (tipo === "PSV") setTipoValvula(2);

        try {
          const ref = doc(db, `valvulas${tipo}`, id); // ex: valvulasBloqueio
          const snapshot = await getDoc(ref);

          if (!snapshot.exists()) {
            console.warn("Válvula não encontrada no Firestore");
            setValvula(null);
            return;
          }

          const data = { id: snapshot.id, ...snapshot.data() };
          setValvula(data);
        } catch (err) {
          console.error("Erro ao buscar válvula:", err);
          setValvula(null);
        }
      } else {
        setValvula(null);
      }
    }

    fetchValvula();
  }, [tipo, id]);

  const botoesDesabilitados = !!valvula || isCliente;

  return (
    <Container userType={userType}>
      <div className="valve-form-container">
        <div className="form-card">
          <div className="form-header">
            <div className="form-header-left">
              <div className="form-icon">
                <SettingOutlined />
              </div>
              <div>
                <h2 className="form-title">{tituloPagina}</h2>
                <p className="form-subtitle">
                  {valvula ? "Visualize os dados da válvula" : "Selecione o tipo e preencha os dados"}
                </p>
              </div>
            </div>
          </div>

          <div className="valve-type-selector">
            <Button
              disabled={botoesDesabilitados}
              className={`valve-type-btn ${tipoValvula === 0 ? "ativo" : ""}`}
              onClick={() => setTipoValvula(0)}
            >
              BLOQUEIO
            </Button>
            <Button
              disabled={botoesDesabilitados}
              className={`valve-type-btn ${tipoValvula === 1 ? "ativo" : ""}`}
              onClick={() => setTipoValvula(1)}
            >
              CONTROLE
            </Button>
            <Button
              disabled={botoesDesabilitados}
              className={`valve-type-btn ${tipoValvula === 2 ? "ativo" : ""}`}
              onClick={() => setTipoValvula(2)}
            >
              PSV
            </Button>
          </div>

          {tipoValvula === 0 && (
            <ValvulaBloqueioForm valvula={valvula} readOnly={isCliente} />
          )}
          {tipoValvula === 1 && (
            <ValvulaControleForm valvula={valvula} readOnly={isCliente} />
          )}
          {tipoValvula === 2 && (
            <ValvulaPSVForm valvula={valvula} readOnly={isCliente} />
          )}
        </div>
      </div>
    </Container>
  );
}

export default ValveForm;
